import "./style.css"


import {
    CircleGeometry,
    Mesh,
    MeshStandardMaterial,
    DirectionalLight,
    PerspectiveCamera,
    Scene,
    WebGLRenderer, AmbientLight, Quaternion, Vector3
} from "three"

import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js"
import { RenderPass } from "three/addons/postprocessing/RenderPass.js"
import { BokehPass } from "three/addons/postprocessing/BokehPass.js"
import loadTextures from "./loadTextures"
import { createCircles } from "./circles"

const TAU = Math.PI * 2

let camera, scene, renderer,
    zmaterial,
    parameters, nobjects, cubeMaterial;

let mouseX = 0, mouseY = 0;

let windowHalfX = window.innerWidth / 2;
let windowHalfY = window.innerHeight / 2;

let width = window.innerWidth;
let height = window.innerHeight;
let textureLoader
let flowers

const materials = [], objects = [];

const postprocessing = {};


const circleGeometryError = 2

const imageWidth = 3024
const imageHeight = 4032

function updateUVs(geometry,x,y,radius)
{
    const attr = geometry.getAttribute("uv");

    const scaleX = (2 * radius)/imageWidth
    const scaleY = (2 * radius)/imageHeight
    const offX = (x - radius)/imageWidth
    const offY = (y - radius)/imageHeight

    console.log({offX,offY,scaleX,scaleY})

    for (let i = 0; i < attr.count; i++)
    {
        // 0-1 for whole circle
        let x = attr.getX(i)
        let y = attr.getY(i)

        attr.setXY(
            i,
            offX + x * scaleX,
            offY + y * scaleY
        )
    }

    attr.needsUpdate = true
}

const Z_SPREAD = 25

function init() {

    const container = document.createElement( 'div' );
    document.body.appendChild( container );

    camera = new PerspectiveCamera( 70, width / height, 1, 3000 );
    camera.position.z = 100;

    scene = new Scene();

    renderer = new WebGLRenderer();
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( width, height );
    container.appendChild( renderer.domElement );

    const directionalLight = new DirectionalLight( 0xffffff, 1 );

    directionalLight.position.set(0,5,10)
    directionalLight.target.position.set(0,0,0)
    directionalLight.target.updateWorldMatrix()

    scene.add( directionalLight );

    createCircles(125).map(
        ({ x,y,radius }) => {

            const modelScale = 0.03

            const segments = Math.ceil(Math.PI / Math.acos(1 - circleGeometryError / radius))
            const geometry = new CircleGeometry(radius * modelScale, segments)

            updateUVs(geometry,x,y,radius)

            const material = new MeshStandardMaterial( { roughness: 0.45, map: flowers } );
            const circle = new Mesh( geometry, material );

            const axis = new Vector3()
            axis.randomDirection()
            const q = new Quaternion();
            q.setFromAxisAngle(axis, (-0.5 + Math.random()) * TAU/8)
            circle.applyQuaternion(q)

            circle.position.set((x - imageWidth/2)  * modelScale,(y - imageHeight/2) * modelScale,(-0.5 + Math.random()) * Z_SPREAD )
            scene.add( circle );
        }
    )

    initPostprocessing();

    renderer.autoClear = false;

    container.style.touchAction = 'none';
    container.addEventListener( 'pointermove', onPointerMove );

    window.addEventListener( 'resize', onWindowResize );

    postprocessing.bokeh.uniforms[ 'focus' ].value = 100;
    postprocessing.bokeh.uniforms[ 'aperture' ].value = 0.00005;
    postprocessing.bokeh.uniforms[ 'maxblur' ].value = 0.02;

}

function onPointerMove( event ) {

    if ( event.isPrimary === false ) return;

    mouseX = event.clientX - windowHalfX;
    mouseY = event.clientY - windowHalfY;

}

function onWindowResize() {

    windowHalfX = window.innerWidth / 2;
    windowHalfY = window.innerHeight / 2;

    width = window.innerWidth;
    height = window.innerHeight;

    camera.aspect = width / height;
    camera.updateProjectionMatrix();

    renderer.setSize( width, height );
    postprocessing.composer.setSize( width, height );

}

function initPostprocessing() {

    const renderPass = new RenderPass( scene, camera );

    const bokehPass = new BokehPass( scene, camera, {
        focus: 1.0,
        aperture: 0.025,
        maxblur: 0.01
    } );

    const composer = new EffectComposer( renderer );

    composer.addPass( renderPass );
    composer.addPass( bokehPass );

    postprocessing.composer = composer;
    postprocessing.bokeh = bokehPass;

}

function animate() {

    requestAnimationFrame( animate);
    render();
}

function render() {

    const time = Date.now() * 0.00005;

    camera.position.x = ( mouseX - camera.position.x ) * 0.036;
    camera.position.y = ( - ( mouseY ) - camera.position.y ) * 0.036;

    camera.lookAt( scene.position );
    
    postprocessing.composer.render( 0.1 );

}


loadTextures(
    ["media/flowers.jpg"]
    ).then(
        ([_flowers]) => {
            flowers = _flowers

            init();
            animate();
        }
    )
